export default {
  display: false,
  headerLabel: '',
  columns: [],
  errors: []
}



// WEBPACK FOOTER //
// ./src/components/_modules/Payment/models/error-model.js